let state: {
  userProfile: any;
  config: any;
} = {
  userProfile: null,
  config: null,
};

export default state;
